export default "__VITE_ASSET__BEBJG4hd__"